var React = require('react');

function IconPhoneInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.67 11.702a7.91 7.91 0 0 0 3.661 3.645.744.744 0 0 0 .734-.056l2.347-1.565a.75.75 0 0 1 .712-.065l4.391 1.882a.75.75 0 0 1 .45.778 4.5 4.5 0 0 1-4.464 3.93A12.75 12.75 0 0 1 3.75 7.5a4.5 4.5 0 0 1 3.93-4.464.75.75 0 0 1 .464.095.75.75 0 0 1 .314.355l1.883 4.395a.75.75 0 0 1-.062.706L8.72 10.97a.744.744 0 0 0-.051.732z","stroke":"#424242","strokeWidth":"1.5","strokeLinejoin":"round"}));
}

IconPhoneInline.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = IconPhoneInline;

IconPhoneInline.default = IconPhoneInline;
